import moveTool from "./move/move-tool.vue";
import turnTool from "./turn/turn-tool.vue";
import createPointTool from "./createpoint/createpoint-tool.vue";
import buttonMachine from "./button-based-tool-xstate.js";

/**
 * This module contains the singleton capturing all interactions of the
 * toolbar and coordinating access to the vue components.
 *
 * So that it can be imported, it is not, itself, a vue component which is left
 * to toolbarCmp.vue.
 */

const tools = [moveTool, turnTool, createPointTool ];
const toolNames = [];
let currentTool = null;
const toolComponents = [];


function init () {
    for (const tool of tools) {
        const toolName = tool.name;
        toolNames.push(toolName);
        console.log("Appending elt ", toolName);
    }
}

function getCurrentTool () {
    return currentTool;
}

function setCurrentTool (tool) {
    currentTool = tool;
}

function resetOthers(toolName) {
    for(const tool of toolComponents) {
        if( tool.name !== toolName && buttonMachine.initialState.value !== tool.current) {
            tool.sendToStateEngine("CANCEL", tool);
        }
    }
}

function mounted(cmp) {
    for (const toolCmp of cmp.$children) {
        toolComponents.push(toolCmp);
    }
    activateDefault();
}

let activateDefaultTimeout = null;

function activateDefault() {
    activateDefaultTimeout = null;
    // verify that all are initial, only then we need to activate one
    for(let toolComp of toolComponents)
        if (toolComp.current !==  buttonMachine.initialState.value)
            return;
    toolComponents[0].sendToStateEngine("ACTIVATE");
}

function reset() {
    toolComponents[0].sendToStateEngine("ACTIVATE");
    for(let i=0; i<toolComponents.length; i++)
        toolComponents[i].sendToStateEngine("DEACTIVATE");
}

function scheduleToActivateDefault() {
    if (activateDefaultTimeout!==null) return;
    activateDefaultTimeout = window.setTimeout(activateDefault, 20);
}

export default  {init, getCurrentTool, setCurrentTool, resetOthers,
    mounted,firstActivation: activateDefault, activateDefault: scheduleToActivateDefault,
    reset: reset,
    tools, toolComponents, toolNames}
